var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 194,
    viewBox: "0 0 107 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: "fixed",
      right: 0,
      zIndex: -1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 65.1877L110.814 2L220.951 65.1877V128.592L111.472 191.78L2 127.717V65.1877Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 127.718L111.255 64.9634L220.517 127.718",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 64.9634L111.255 127.71L220.517 64.9634",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloater);
export default __webpack_public_path__ + "static/media/floater.8cf13bc2d501faec366cfaa5c2c05d2d.svg";
export { ForwardRef as ReactComponent };